import React from 'react';

import PropTypes from 'prop-types';

import { TextActivityCard } from '@adsk/alloy-react-activity-log';
import { useLocale } from '@adsk/alloy-react-locale';

import { ACTIVITY_VARIANTS } from '../../constants';

const PackagesActivityCard = ({ entity, variant, ...rest }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  return (
    <TextActivityCard
      {...rest}
      title={
        variant === ACTIVITY_VARIANTS.REMOVED
          ? T.translate('ACTIVITY_TITLE_REMOVED')
          : T.translate('ACTIVITY_TITLE_ADDED')
      }
      text={T.translate('PACKAGE_ID_AND_NAME', {
        displayId: entity.displayId,
        name: entity.name,
      })}
    />
  );
};

PackagesActivityCard.propTypes = {
  variant: PropTypes.oneOf(Object.values(ACTIVITY_VARIANTS)),
  entity: PropTypes.object,
};

export default PackagesActivityCard;
